import { RestClient } from '@/api/rest-client'
import { Pipeline } from '@/api/model/pipeline'
import { cloneDeep } from 'lodash'
import { Branch } from '@/api/model/branch'
import { BranchOperatingZone } from '@/api/model/branch-operating-zone'

export class BranchOperatingZoneClient extends RestClient<BranchOperatingZone> {
    collectionName = 'branch_operating_zones'
    parseData = BranchOperatingZone.fromData

    async create(data: BranchOperatingZone): Promise<BranchOperatingZone> {
        const request = cloneDeep<any>(data)

        if (data.pipeline instanceof Pipeline) {
            request.pipeline = data.pipeline.resourceIdentifier
        }

        if (data.branch instanceof Branch) {
            request.branch = data.branch.resourceIdentifier
        }

        return super.create(request)
    }

    async update(id: string, data: BranchOperatingZone): Promise<BranchOperatingZone> {
        const request = cloneDeep<any>(data)

        if (data.pipeline instanceof Pipeline) {
            request.pipeline = data.pipeline.resourceIdentifier
        }

        if (data.branch instanceof Branch) {
            request.branch = data.branch.resourceIdentifier
        }
        return super.update(id, request)
    }

    protected handleError(error: any) {
        throw error
    }
}
